export default "__VITE_ASSET__DH8aRBee__"